import { takeLatest, put, call } from 'redux-saga/effects';
import { getPropertiesReducer } from './properties/PropertiesSlice';
import { updateUserLanguageAPI } from './user/api';

// Watch for the setLanguage action using the exact action type from your slice
export function* watchLanguageChange() {
  yield takeLatest('language/setLanguage', refreshDataOnLanguageChange);
}

// This saga runs whenever the language changes
function* refreshDataOnLanguageChange(action) {
  console.log('Language changed to:', action.payload);
  
  // Persist to localStorage
  localStorage.setItem('language', JSON.stringify(action.payload));

  // Persist to DB if user is logged in
  const isLoggedIn = localStorage.getItem('userLogged');
  if (isLoggedIn) {
    try {
      yield call(updateUserLanguageAPI, action.payload);
    } catch (error) {
      console.error('Failed to persist language preference to DB:', error);
    }
  }
  
  // Trigger property refresh
  yield put(getPropertiesReducer());
}